export const MAX_IMAGE_INDEX = 2;
export const IMAGE_SIZE = 45;
export const DEFAULT_SIZE = 100;
